import { render } from "./SuccessView.vue?vue&type=template&id=51c2454c"
import script from "./SuccessView.vue?vue&type=script&lang=js"
export * from "./SuccessView.vue?vue&type=script&lang=js"

import "./SuccessView.vue?vue&type=style&index=0&id=51c2454c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__